import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardTitle, CardText, Form, Row,Col,CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const modeloDatos = {
    prestamoID: 0,
    empresaID: 1,
    noPoliza: "",
    cedula: "",
    nombre: "",
    fecha: new Date(),
    fechaInicioPrestamo: new Date(),
    garantia: "",
    montoPrestado: 0.00,
    tasaInteres: 5.00,
    balanceCapital: 0.00,
    totalInteresPagado: 0.00,
    comentario: "",
    creadoPor: "1",
    interesPagado: 0.00,
    terminado: 0,
    formaCalculoInteres:'quincenal',
    fechaPropuestaPerdida: new Date()

}
const modeloDatosPagos = {
    pagoPrestamoID: 0,
    empresaID: 1,
    prestamoID: 0,
    noPoliza: "",
    nombre: "",
    fecha: new Date(),
    interesGenerado: 0.00,
    capitalAlmomento: 0.00,
    fechaDelPrestamo: 0.00,
    capitalPagado: 0.00,
    interesPagado: 0.00,
    creadoPor: "",
    fechaCreado: new Date()
}

const Version = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [tablaPago, setTablaPago] = useState(modeloDatosPagos);
    const [tablaPrint, settablaPrint] = useState(modeloDatosPagos);
    const [Listado, SetListado] = useState([]);
    const [ListadoPago, SetListadoPagos] = useState([]);
    const [ListadoLinea, SetListadoLinea] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [verModalImpresion, setVerModalImpresion] = useState(false);
    const [verModalPago, setVerModalPago] = useState(false);
    const [verMovil, setverMovil] = useState(false);
    const [busqueda, setbusqueda] = useState();
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Empresa, setEmpresa] = useState([]);

    let correo = JSON.parse(user);

    const handleChange = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        if (e.target.name == "cedula" && e.target.value.length > 10) {
            ValidarCedula(e.target.value);
        }
        let value = e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }
    //Validar Cedula
    const ValidarCedula = async (x) => {

        var nomb = Listado.filter(e => e.cedula == x).map(d => d);

        if (nomb.length != 0) {
            tabla.nombre = (nomb[0]).nombre;
            tabla.cedula = x; 
        }
        else {
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
            if (response1.ok) {
                let data1 = await response1.json()
                if (data1 != false) {
                    setTabla({
                        ...tabla, nombre: (data1[0]).nombres + " " + (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x
                    })
                } else {
                    setTabla({
                        ...tabla, nombre: "", cedula: x
                    })
                }
            }
        }
    }

    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + JSON.parse(user).empresaID);
        if (response.ok) {
            let data = await response.json();
            setEmpresa(data)
        }
    }

    const handleChangePago1 = (e) => {
        //let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        let value = parseFloat( e.target.value);
        setTablaPago({
            ...tablaPago,
            [e.target.name]: value
        })

        tablaPago.totalPagado = (parseFloat(tablaPago.interesGenerado) +
            parseFloat(tablaPago.capitalPagado))
    } 

   
    const onChangeb = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
              ( item.noPoliza+ item.telefono + item.nombre + item.cedula)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            } 
        });
        SetListado(searchData);
    };

    const obtenerDatos = async () => {
        let response = await fetch(Api + "Prestamos/Lista/a" );
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if( pendiente){
                SetListado  (data)
            }
            setPendiente(false)
       
           
           
        }
    }
    const obtenerDatosPagos = async (p) => {
        let response = await fetch(Api + "Prestamos/ListaPagos/"+p );
        if (response.ok) {
            let data = await response.json()
            SetListadoPagos(data)
            
           
           
        }
    }
 
    const Pagado = async (x) => {
        let response = await fetch(Api + "Transporte/ListaPrestamosLineas/"+x );
        if (response.ok) {
            let data = await response.json()
            SetListadoLinea(data)           
        }
    }

    const GenerarCuota = async (e) => {
        let response = await fetch(Api + "Transporte/GenerarCuota/" +e);
        if (response.ok) {
            let data = await response.json()
            SetListadoLinea(data)  
           
           
        }
    }

    useEffect(() => {
        obtenerDatos();
    })
    useEffect(() => {
        obtenerDatosEmpresa();
    },[])


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }

    //Guardar datos
    const guardarCambios = async () => {
        let response;
        if (tabla.prestamoID == 0) {
            tabla.creadoPor = JSON.parse(user).correo;
            tabla.balanceCapital = tabla.montoPrestado;
            tabla.fechaUltimoPago = tabla.fechaInicioPrestamo;
            response = await fetch(Api + "Prestamos/Guardar", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
     
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "Transporte/EditarPrestamos", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
           
            //let data = await response.json()
            cerrarModal()
        } else {
            alert("error al guardar")
        }

    }
    //ProcesoPago
    const ProcesoPago = async () => {
        let response;

        tablaPago.prestamoID = tabla.prestamoID;
        tablaPago.noPoliza = tabla.noPoliza;
        tablaPago.nombre = tabla.nombre;
        //tablaPago.interesGenerado = (tabla.balanceCapital * (tabla.tasaInteres / 100));
        tablaPago.capitalAlmomento = tabla.balanceCapital;
        tablaPago.interesPagado = tablaPago.interesGenerado;
        tablaPago.totalPagado = tablaPago.interesGenerado + tablaPago.capitalPagado;

       

        if (tablaPago.pagoPrestamoID == 0) {
            tablaPago.creadoPor = JSON.parse(user).correo;
         
            response = await fetch(Api + "Prestamos/ProcesarPago", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tablaPago)
            })

        } 

        if (response.ok) {
            obtenerDatos()
            let data = await response.json()
           
            setVerModalImpresion(true)
        } else {
            alert("error al guardar")
        }

    }
    //const eliminarDatos = async (id) => {

    //    Swal.fire({
    //        title: 'Esta seguro?',
    //        text: "Desea eliminar el producto",
    //        icon: 'warning',
    //        showCancelButton: true,
    //        confirmButtonColor: '#3085d6',
    //        cancelButtonColor: '#d33',
    //        confirmButtonText: 'Si, continuar',
    //        cancelButtonText: 'No, volver'
    //    }).then((result) => {
    //        if (result.value) {
    //            const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
    //                .then(response => {
    //                    if (response.ok) {
    //                        obtenerDatos();
    //                        Swal.fire(
    //                            'Eliminado!',
    //                            'El producto fue eliminado.',
    //                            'success'
    //                        )
    //                    }
    //                })
    //        }
    //    })
    //}

    const ReimprimirPago = (x) => {
        setTablaPago(x)
        setVerModalImpresion(true)
    }

    const abrirEditarModalMovil = (data) => {
        setTabla(data);
     
        setverMovil(!verMovil);
    }
    const abrirEditarModal = (data) => {
        setTabla(data);
        calcularInteres(data.balanceCapital , "quincenal")
        obtenerDatosPagos(data.prestamoID)
        setVerModalPago(!verModalPago);
    }
    const cerrarModal = () => {
        setPendiente(true)
        obtenerDatos()
        setTabla(modeloDatos)
        setTablaPago(modeloDatosPagos)
        setVerModal(false)
        setVerModalImpresion(false)
        setVerModalPago(false)
        setverMovil(false)

    }

    

    const columns = [
     
        {
            name: 'Poliza ',
            selector: row => row.noPoliza,
            sortable: true,
            width: '12%',
        },
       
         {
            name: 'Nombre ',
            selector: row => row.nombre,
             sortable: true,
             width: '27%',
        },
       
      
             {
            name: 'Capital',
                 selector: row => toMoney( row.montoPrestado),
                 sortable: true,
                 width: '12%',
        },     {
                 name: 'Capital Pagado',
                 selector: row => toMoney(row.montoPrestado - row.balanceCapital  ),
                 sortable: true,
                 width: '12%',
        },
                {
            name: 'Ultimo Pago',
            selector: row => (<>
                {<a onClick={() => abrirEditarModalMovil(row)}> {moment(row.fechaUltimoPago).format("DD/MM/YYYY")}</a>}

            </>),
                    sortable: true,
                    width: '12%',
        },
       
        {
            name: '',
            cell: row => ( 
                <>
                    {(row.balanceCapital >= 0.01)?(
                    <Button color="success" size="sm" className="mr-2" 
                        onClick={() => abrirEditarModal(row)} title="Cobrar Cuota"
                    >
                        <i className="fas  fa-money-bill"></i>
                    </Button>
                  ):("")}

                </>
            ),
            width: '10%',
        },
    ];
    const columnsLineas = [
        {
            name: 'Cuota',
            selector: row => row.cuotaNum,
            sortable: true,
        },
        {
            name: 'Dia ',
            selector: row => "Sabado",
            sortable: true,
        },
       
      
             {
            name: 'Fecha',
                 selector: row => row.descripcionFecha,
            sortable: true,
        },     {
                 name: 'Pago',
                 selector: row => row.montoCuota,
            sortable: true,
        },
        {
            name: 'X',
            selector: row => row.pago,
            sortable: true,
        },   {
            name: 'Restante',
            selector: row => row.restante,
            sortable: true,
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                  

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    const toMoney = (value) => {
        const money = Number(value);

        if (isNaN(money)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }

    const estilos = ` 
<style>
body {
            font-family: Arial, sans-serif;
            width: 300px;
            margin: auto;
           
            padding: 10px;
            text-align: center;
        }
        .title {
            font-size: 18px;
            font-weight: bold;
        }
        .info {
            text-align: left;
            font-size: 12px;
        }
        .factura {
            border-top: 1px solid black;
            border-bottom: 1px solid black;
            margin: 10px 0;
            padding: 5px 0;
        }
        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
        }
        th, td {
            border-bottom: 1px solid black;
            padding: 5px;
color: #0000000 !important
        }
        .total {
            font-weight: bold;
        }
</style>
`;
    const imprimirRecibo = () => {
        const recibo = document.getElementById("reciboPago").innerHTML;
        const ventana = window.open("", "", "width=600,height=400");
        ventana.document.write("<html><head>   <title>Recibo de Pago</title>");
        ventana.document.write(estilos);
        ventana.document.write("</head><body>");
        ventana.document.write(recibo);
        ventana.document.write("</body></html>");
        ventana.document.close();
        ventana.print();
    };

    function calcularInteres(monto, periodo, cantidadPeriodos = 1) {
        const tasa = tabla.tasaInteres / 100; // 5% por periodo
        let dias = 1
      
        //Dias
        switch (periodo.toLowerCase()) {
            case 'semanal':
                dias = 7; // 52 semanas al año
                break;
            case 'quincenal':
                dias = 15; // 24 quincenas al año
                break;
            case 'mensual':
                dias = 30; // 12 meses al año
                break;
            case 'anual':
                dias = 365; // ya está anual
                break;
        }
        if (tabla.fechaUltimoPago == null) { tabla.fechaUltimoPago = tabla.fechaInicioPrestamo }
        const fecha1 = new Date(tabla.fechaUltimoPago);
        const fecha2 = new Date(tablaPago.fecha)
        let diastranscurrido = (fecha2 - fecha1) / (1000 * 60 * 60 * 24)
        let promediointeres = diastranscurrido / dias;
        // Lista de periodos válidos
        const periodosValidos = ['semanal', 'quincenal', 'mensual', 'anual'];
        if (!periodosValidos.includes(periodo.toLowerCase())) {
            throw new Error("Periodo no válido. Usa: semanal, quincenal, mensual o anual.");
        }

        const interes = monto * tasa * cantidadPeriodos;
        const interes1 = interes * promediointeres;
tablaPago.interesGenerado = interes1.toFixed(2);
        if (interes1 <= 0) { tablaPago.interesGenerado = 0 } 
        return interes1;
    }

    function calcularInteres1(monto, periodo) {
        const tasaAnual = 0.05; // 5%

        // Convertimos la tasa anual según el periodo
        let tasa;

        switch (periodo.toLowerCase()) {
            case 'semanal':
                tasa = tasaAnual / 52; // 52 semanas al año
                break;
            case 'quincenal':
                tasa = tasaAnual / 24; // 24 quincenas al año
                break;
            case 'mensual':
                tasa = tasaAnual / 12; // 12 meses al año
                break;
            case 'anual':
                tasa = tasaAnual; // ya está anual
                break;
            default:
                throw new Error("Periodo no válido. Usa: semanal, quincenal, mensual o anual.");
        }

        const interes = monto * tasa;
        return interes;
    }


    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de prestamos
                </CardHeader>
                <CardBody>
                 <Row>  
                    <Col md="8">
                            <Input type="search" name="busqueda" onChange={(e) => onChangeb(e)} placeholder="Buscar por poliza / nombre / cedula / telefono " ></Input>
                        </Col>
                        <Col md="4">     <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Prestamo</Button></Col></Row> 
                    <hr></hr>

                    <Tabs >
                        <TabList>
                            <Tab ><b>Polizas Actuales</b></Tab>
                            <Tab style={{color:"red"} }><b>Polizas Vencidos</b></Tab>
                            <Tab style={{ color: "green" }}><b>Polizas Saldas</b></Tab>
                        </TabList>

                        <TabPanel>
                           
                            {/*Actual*/}
                            <DataTable
                                columns={columns}
                                data={Listado.filter(x => x.estatus1 == 'Activo' )}
                                progressPending={pendiente}
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                customStyles={customStyles}
                            />
                        </TabPanel>
                        <TabPanel> 
                            {/*Perdido*/}
                            <DataTable
                                columns={columns}
                                data={Listado.filter(x => x.estatus1 == 'Perdido')}
                                progressPending={pendiente}
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                customStyles={customStyles}
                            />
                        </TabPanel>
                        <TabPanel>
                            {/*Perdido*/}
                            <DataTable
                                columns={columns}
                                data={Listado.filter(x => x.terminado == 1)}
                                progressPending={pendiente}
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                customStyles={customStyles}
                            />
                        </TabPanel>
                    </Tabs>


                
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="modal-preguntas">
                <ModalHeader className=" modal-header1">
                    Prestamos
                </ModalHeader>
                <ModalBody>
                    <Row>
                       
                        <Col md={3}>
                            <FormGroup>
                                <Label for="noPoliza"><b>No. Póliza</b></Label>
                                <Input type="text" name="noPoliza" value={tabla.noPoliza} onChange={handleChange} required />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="cedula"><b>Cédula</b></Label>
                                <Input type="text" name="cedula" value={tabla.cedula} onChange={handleChange} required />
                            </FormGroup>
                        </Col>    <Col md={3}>
                            <FormGroup>
                                <Label for="nombre"><b>Nombre</b></Label>
                                <Input type="text" name="nombre" value={tabla.nombre} onChange={handleChange} required />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="tasaInteres"><b>Periodo %</b></Label>
                                <select name="formaCalculoInteres" value={tabla.formaCalculoInteres} onChange={handleChange} >
                                    <option value={"quincenal"} >Quincenal</option>
                                    <option value={"mensual"} >Mensual</option>
                                    <option value={"semanal"} >Semanal</option>
                                    <option value={"anual"} >Anual</option>
                                </select>
                            </FormGroup>
                        </Col> 
                    </Row>
                    <Row>
                    
                        {/*<Col md={4}>*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label for="fecha">Fecha</Label>*/}
                        {/*        <Input type="date" name="fecha" value={tabla.fecha} onChange={handleChange} required />*/}
                        {/*    </FormGroup>*/}
                        {/*</Col>*/}
                        <Col md={3}>
                            <FormGroup>
                                <Label for="fechaInicioPrestamo"><b>Fecha Inicio Préstamo</b></Label>
                                <Input type="date" name="fechaInicioPrestamo" value={moment(tabla.fechaInicioPrestamo).format("YYYY-MM-DD")} onChange={handleChange} required />
                            </FormGroup>
                        </Col>
                      <Col md={3}>
                            <FormGroup>
                                <Label for="fechaInicioPrestamo"><b>Fecha Propuesta Entrega</b></Label>
                                <Input type="date" name="fechaPropuestaPerdida" value={moment(tabla.fechaPropuestaPerdida).format("YYYY-MM-DD")} onChange={handleChange} required />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="tasaInteres"><b>Tasa %</b></Label>
                                <Input type="number" name="tasaInteres" value={tabla.tasaInteres} onChange={handleChange} required />
                            </FormGroup>
                        </Col>
                      
                        <Col md={3}>
                            <FormGroup>
                                <Label for="montoPrestado"><b>Monto Prestado</b></Label>
                                <Input type="number" name="montoPrestado" value={tabla.montoPrestado} onChange={handleChange} required />
                            </FormGroup>
                        </Col>
                      
                    </Row>
                    <Row>
                    
                       <Col md={6}>
                            <FormGroup>
                                <Label for="garantia"><b>Garantía</b></Label>
                                <Input type="textarea" name="garantia" value={tabla.garantia} onChange={handleChange} required />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="comentario"><b>Comentario</b></Label>
                                <Input type="textarea" name="comentario" value={tabla.comentario} onChange={handleChange} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <h4>   Primer Interes a Pagar: {toMoney(tabla.montoPrestado * (tabla.tasaInteres / 100)) }</h4>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                      //   onClick={GenerarCuota}
                       onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*////Proceso de pago*/ }    
            <Modal isOpen={verModalPago} className="modal-preguntas" style={{width: "110%"} }>
            
                <ModalBody>
<div className="box">
                    <div class="bg-white rounded-xl shadow-md overflow-hidden mb-6">
                        <div class="bg-gradient-to-r from-blue-500 to-blue-700 p-4">
                            <h2 class="text-white text-xl font-semibold flex items-center">
                                <i data-lucide="dollar-sign" class="mr-2"></i> Detalles del Préstamo
                            </h2>
                        </div>

                        <div class="p-5">
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div class="space-y-4">
                                    <div class="flex justify-between border-b pb-2">
                                        <span class="font-medium text-gray-600">No. Póliza:</span>
                                            <span class="font-bold">{tabla.noPoliza}</span>
                                    </div>
                                    <div class="flex justify-between border-b pb-2">
                                        <span class="font-medium text-gray-600">Nombre:</span>
                                            <span class="font-bold">{tabla.nombre}</span>
                                    </div>
                                    <div class="flex justify-between border-b pb-2">
                                        <span class="font-medium text-gray-600">Último Pago:</span>
                                        <span class="font-bold flex items-center">
                                            <i data-lucide="calendar" class="w-4 h-4 mr-1"></i>
                                                {moment(tabla.fechaUltimoPago).format("DD/MM/YYYY")}
                                        </span>
                                        </div>
                                        <div class="flex justify-between border-b pb-2">
                                        <span class="font-medium text-gray-600">Calc interes:</span>
                                        <span class="font-bold flex items-center">
                                            <i data-lucide="calendar" class="w-4 h-4 mr-1"></i>
                                            
                                                {tabla.formaCalculoInteres}
                                        </span>
                                    </div>
                                </div>

                                <div class="space-y-4">
                                    <div class="flex justify-between border-b pb-2">
                                        <span class="font-medium text-gray-600">Balance Capital:</span>
                                            <span class="font-bold text-red-600">{toMoney(tabla.balanceCapital)}</span>
                                    </div>
                                    <div class="flex justify-between border-b pb-2">
                                        <span class="font-medium text-gray-600">Interés Pagado:</span>
                                            <span class="font-bold text-red-600">{toMoney(tabla.interesPagado)}</span>
                                    </div>
                                    <div class="flex justify-between border-b pb-2">
                                        <span class="font-medium text-gray-600">Estado:</span>
                                        <span class="inline-flex items-center bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-sm">
                                            Pendiente de pago
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bg-white rounded-xl shadow-md overflow-hidden mb-6">
                        <div class="bg-gradient-to-r from-green-500 to-green-700 p-4">
                            <h2 class="text-white text-xl font-semibold">Datos de Facturación</h2>
                        </div>

                        <div class="p-5">
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                                <div class="space-y-2">
                                    <label class="block text-sm font-medium text-gray-700">Fecha de Pago</label>
                                    <div class="relative">
                                        <div class="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-gray-50">
                                            <i data-lucide="calendar" class="w-5 h-5 text-gray-500 mr-2"></i>
                                     
                                                <input type="date" class="flex-grow outline-none bg-transparent" id="fechaPago" name="fechaPago" value={moment(tablaPago.fechaPago).format("YYYY-MM-DD")} onChange={handleChangePago1} required />

                                        </div>
                                    </div>
                                </div>

                                <div class="space-y-2">
                                    <label class="block text-sm font-medium text-gray-700">Monto Interés</label>
                                    <div class="relative">
                                        <div class="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-gray-50">
                                            <i data-lucide="dollar-sign" class="w-5 h-5 text-gray-500 mr-2"></i>
                                        
                                                <input type="number" id="montoInteres" name="montoInteres" disabled class="flex-grow outline-none bg-transparent"
                                                    value={tablaPago.interesGenerado} required />
                                               <div hidden> {calcularInteres(tabla.balanceCapital,"quincenal") }</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="space-y-2">
                                    <label class="block text-sm font-medium text-gray-700">Capital a Pagar</label>
                                    <div class="relative">
                                        <div class="flex items-center border border-gray-300 rounded-lg px-3 py-2 bg-gray-50">
                                            <i data-lucide="dollar-sign" class="w-5 h-5 text-gray-500 mr-2"></i>
                                     
                                                <input type="number" name="capitalPagado" onChange={handleChangePago1} value={tablaPago.capitalPagado} required class="flex-grow outline-none bg-transparent" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-col md:flex-row justify-between items-center bg-blue-50 p-4 rounded-lg mb-6">
                                <div class="flex items-center">
                                    <div class="mr-3 bg-blue-500 p-2 rounded-full">
                                        <i data-lucide="dollar-sign" class="w-6 h-6 text-white"></i>
                                    </div>
                                    <div>
                                        <h3 class="text-blue-800 font-semibold">Total a Pagar</h3>
                                     </div>
                                </div>
                                    <div class="text-2xl font-bold text-blue-800 mt-3 md:mt-0">
                                        {/*{calcularInteres(tabla.balanceCapital, "quincenal") }*/}
                                       
                                        {toMoney(parseFloat(tablaPago.interesGenerado) +
                                            parseFloat(tablaPago.capitalPagado))}

                                    {/*    {toMoney(tablaPago.totalPagado)}*/}
                                </div>
                            </div>

                                <div class="flex justify-center">
                                    {!(parseFloat(tablaPago.interesGenerado) +
                                    parseFloat(tablaPago.capitalPagado))?"No existe ningun monto a cobrar":
                                <button
                                        onClick={() => ProcesoPago()}
                                    class="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold py-2 px-6 rounded-lg flex items-center shadow-lg transform transition hover:scale-105"
                                >
                                    Registrar Pago
                                    <i data-lucide="arrow-right" class="ml-2"></i>
                                </button>   }
                            </div>
                        </div>
                    </div>
                    </div>

                    <div class="bg-white rounded-xl shadow-md overflow-hidden">
                        <div class="bg-gradient-to-r from-purple-500 to-purple-700 p-4">
                            <h2 class="text-white text-xl font-semibold flex items-center">
                                <i data-lucide="pie-chart" class="mr-2"></i> Historial de Pagos
                            </h2>
                        </div>

                        <div class="overflow-x-auto">
                            <table class="min-w-full table">
                                <thead>
                                    <tr class="bg-gray-50">
                                        <th class="py-3 px-4 text-left font-semibold">Fecha</th>
                                        <th class="py-3 px-4 text-left  font-semibold">Interés</th>
                                        <th class="py-3 px-4 text-left  font-semibold">Capital</th>
                                        <th class="py-3 px-4 text-left  font-semibold">Total</th>
                                        <th class="py-3 px-4 text-left  font-semibold"></th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-gray-200">
                                
                                    {(ListadoPago.length < 1) ? ("Esperando Los pagos")
                                        : (ListadoPago.map(x => (
                                            <tr class="hover:bg-gray-50">
                                                <td>{moment(x.fecha).format("DD/MM/YYYY")}</td>
                                                <td>{toMoney(x.interesPagado)}</td>
                                                <td>{toMoney(x.capitalPagado)}</td>
                                                <td>{toMoney(x.interesPagado + x.capitalPagado)}</td>
                                                <td>   <button
                                                    onClick={() => ReimprimirPago(x)}
                                                    class="btn"
                                                >
                                                    <i data-lucide="arrow-right" class="ml-1 fa fa-print"></i>
                                                </button></td>
                                            </tr>
                                        )))
                                    }
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
              

                       
                </ModalBody>
                <ModalFooter>
              
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



            {/*////Recibo*/}
            <Modal isOpen={verModalImpresion} className="modal-preguntas">
                <ModalHeader className=" modal-header1">
                    Pago de Prestamo
                </ModalHeader>
                <ModalBody>
                    <div id="reciboPago" className="mt-4 p-3">


                        <div class="title">{Empresa.descripcion }</div>
                        <div class="info">
                            { Empresa.direccion}<br/>
                            {Empresa.telefono }<br/>
                                 
                            Fecha: {moment(tablaPago.fecha).format("DD/MM/YYYY")}<br/>
                            Cliente: {tablaPago.nombre}<br/>
                            Poliza: {tablaPago.noPoliza}<br/>
                                                    </div>
                        <div class="factura">R E C I B O</div>
                        <p><strong>Capital Pagado:</strong>{toMoney(tablaPago.capitalPagado)} </p>
                        <p><strong>Interés Pagado:</strong>{toMoney(tablaPago.interesPagado)} </p>
                        <p><strong>Total Pagado:</strong>{toMoney(tablaPago.interesPagado + tablaPago.capitalPagado)} </p>

                                                    <br/>
                                                        <div class="info">
                                                            {/*Sub-Total: 1,00<br/>*/}
                                                            {/*    Itbis: 0,18<br/>*/}
                                                            {/*        Desc.: 0,00<br/>*/}
                                                            {/*            <span class="total">Total: 1,18</span><br/>*/}
                                                            {/*                Cambio: 0,82<br/>*/}
                                                                            </div>
                                                                            <br/>

                        <div class="info">Le atendió: {JSON.parse(user).nombre}</div>
                                                                                    <br/>
                                                                                        <div class="info">Conserve su ticket para cualquier reclamo.</div>
                                 
                
                        </div>
                       
                        <Button color="secondary" onClick={() => imprimirRecibo()}>Imprimir Recibo</Button>
                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
    )

}
export default Version;